
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/security",
      function () {
        return require("private-next-pages/qmee/security.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/security"])
      });
    }
  